import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// Dyeing
export const getProduccionFechaSemanaTintoreria = async(data) => {
   const respuesta = await PrivateInterceptor(`Produccion/Dyeing/Kpis/kpiWeek/${data.week}/${data.year}`, 'GET')
   return respuesta;
}

export const getProduccionFechaMesTintoreria = async (body) => {
   const respuesta = PrivateInterceptor('Produccion/Dyeing/Kpis/Metas', 'POST', body);
   return respuesta;
}

export const getProduccionFechaMesTint = async (body) => {
   const respuesta = PrivateInterceptor('Produccion/Dyeing/Kpis/MetasPunteadas', 'POST', body);
   return respuesta;
}

export const getProduccionDiaria = async (body) => {
   const respuesta = await PrivateInterceptor('Produccion/Dyeing/Kpis/MetasDiarias', 'POST', body);
   return respuesta;
}

// getProduccionMesSemanaTintoreria
export const getProduccionMesSemanaTintoreria = async(data) => {
   const respuesta = await PrivateInterceptor(`Produccion/Dyeing/Kpis/kpiMesSemana/${data.month}/${data.year}`, 'GET')
   return respuesta;
}
export const getProduccionFechaTintoreria = async(data) => {
   const respuesta = await PrivateInterceptor(`Produccion/Dyeing/Kpis/kpiDates/${data.week}/${data.year}`, 'GET')
   return respuesta;
}

// knitting
export const getProduccionFechaSemanaTejido = async(data) => {
   const respuesta = await PrivateInterceptor(`Produccion/Knitting/kpiWeek/${data.week1}/${data.year1}/${data.week2}/${data.year2}`, 'GET')
   return respuesta;
}
export const getProduccionFechaTejido = async(data) => {
   const respuesta = await PrivateInterceptor(`Produccion/Knitting/kpiDates/${data.week1}/${data.year1}`, 'GET')
   return respuesta;
}

// Finishing
export const getProduccionFechaSemanaFinishing = async(data) => {
   const respuesta = await PrivateInterceptor(`Produccion/Finishing/kpiWeek/${data.week1}/${data.year1}/${data.week2}/${data.year2}`, 'GET')
   return respuesta;
}
export const getProduccionFechaFinishing = async(data) => {
   const respuesta = await PrivateInterceptor(`Produccion/Finishing/kpiDates/${data.week1}/${data.year1}`, 'GET')
   return respuesta;
}
// Finishing
export const getProduccionFechaSemanaExport = async(data) => {
   const respuesta = await PrivateInterceptor(`Produccion/Export/kpiWeek/${data.week1}/${data.year1}`, 'GET')
   return respuesta;
}
export const getProduccionFechaExport = async(data) => {
   const respuesta = await PrivateInterceptor(`Produccion/Export/kpiDates/${data.week1}/${data.year1}`, 'GET')
   return respuesta;
}